<template>
  <div class="sidebar-container">
    <base-menu />
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>

.sidebar-container {
  padding: .5rem;
  border-right: solid 3px #eeeeee;
}

</style>
